import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/common/SEO';
import FAQSection from '../components/common/FAQSection';

function RecruiterAgent() {
  return (
    <>
      <SEO pathname="/agents/recruiter-agent" agentKey="RecruiterAgent" />

    <div style={{ minHeight: '100vh', background: '#F9FAFB', paddingTop: '120px', paddingBottom: '100px', fontFamily: '"General Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Breadcrumb */}
        <nav style={{ marginBottom: '32px' }}>
          <Link to="/" style={{ color: '#0071e3', textDecoration: 'none', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '0.95rem' }}>
            <span style={{ fontSize: '1.2rem' }}>←</span> Back to Home
          </Link>
        </nav>

        {/* Hero Section */}
        <div style={{ display: 'flex', gap: '60px', alignItems: 'center', marginBottom: '80px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1.2', minWidth: '400px' }}>
            <div style={{ display: 'inline-block', padding: '8px 16px', background: 'rgba(99, 102, 241, 0.1)', color: '#6366F1', borderRadius: '100px', fontSize: '0.9rem', fontWeight: '600', marginBottom: '24px' }}>
              Human Capital Management
            </div>
            <h1 style={{ fontSize: '3.5rem', fontWeight: '800', color: '#111827', lineHeight: '1.1', marginBottom: '24px', letterSpacing: '-0.02em' }}>
              Recruiter <span style={{ background: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Agent</span>
            </h1>
            <p style={{ fontSize: '1.25rem', color: '#4B5563', lineHeight: '1.6', marginBottom: '40px' }}>
              Autonomous candidate sourcing, screening, and outreach. Transform your hiring funnel with an agent that understands resumes as well as your hiring managers do.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="https://app.eagentix.com/register?reason=Requesting%20access%20to%20Recruiter%20Agent" target="_blank" rel="noopener noreferrer" style={{ padding: '16px 32px', background: '#111827', color: 'white', borderRadius: '12px', fontWeight: '600', fontSize: '1.05rem', textDecoration: 'none', transition: 'all 0.2s', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
                Deploy Now
              </a>
              <button style={{ padding: '16px 32px', background: 'white', color: '#111827', borderRadius: '12px', fontWeight: '600', fontSize: '1.05rem', border: '1px solid #E5E7EB', cursor: 'pointer' }}>
                View Architecture
              </button>
            </div>
          </div>
          
          <div style={{ flex: '1', minWidth: '400px' }}>
            <div style={{ position: 'relative', padding: '24px', background: 'white', borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.08)', border: '1px solid #F3F4F6' }}>
              <img 
                src="/images/architectures/recruiter-flow.png" 
                alt="Recruiter Agent Workflow Topology" 
                style={{ width: '100%', height: 'auto', borderRadius: '12px' }}
              />
              <div style={{ position: 'absolute', bottom: '12px', right: '36px', fontSize: '0.75rem', color: '#9CA3AF', fontStyle: 'italic' }}>
                High-fidelity HCM Topology v2.1
              </div>
            </div>
          </div>
        </div>

        {/* Capabilities Grid */}
        <div style={{ marginBottom: '100px' }}>
          <h2 style={{ fontSize: '2.25rem', fontWeight: '800', color: '#111827', marginBottom: '48px', textAlign: 'center' }}>Hiring Core Capabilities</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '24px' }}>
            
            <div style={{ padding: '32px', background: 'white', borderRadius: '20px', border: '1px solid #F3F4F6', transition: 'all 0.2s' }}>
              <div style={{ width: '48px', height: '48px', background: '#EEF2FF', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', color: '#6366F1' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>Intelligent Shortlisting</h3>
              <p style={{ color: '#4B5563', lineHeight: '1.5' }}>Upload 1,000+ resumes and a JD. The agent ranks candidates based on project-level evidence, not just keyword matching.</p>
            </div>

            <div style={{ padding: '32px', background: 'white', borderRadius: '20px', border: '1px solid #F3F4F6' }}>
              <div style={{ width: '48px', height: '48px', background: '#F0FDF4', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', color: '#22C55E' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>JD Generation</h3>
              <p style={{ color: '#4B5563', lineHeight: '1.5' }}>Converts messy internal notes into professional, SEO-optimized job descriptions that attract high-intent specialized talent.</p>
            </div>

            <div style={{ padding: '32px', background: 'white', borderRadius: '20px', border: '1px solid #F3F4F6' }}>
              <div style={{ width: '48px', height: '48px', background: '#FFF7ED', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', color: '#F97316' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>Autonomous Screening</h3>
              <p style={{ color: '#4B5563', lineHeight: '1.5' }}>Conducts initial discovery calls via voice to verify availability, salary expectations, and cultural alignment before human review.</p>
            </div>

          </div>
        </div>

      </div>
    </div>
    <FAQSection agentKey="RecruiterAgent" />
    </>
  );
}

export default RecruiterAgent;
